// pdf.js setup shared by the document viewer and the pre-upload page counter: the worker location and the
// `getDocument` options that tell pdf.js where its run-time files are.
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

// Copied into the build under /pdfjs/ by vite.config.ts. Absolute URLs, because the worker resolves them, not the
// page. Without `wasmUrl` pdf.js skips JBIG2 and CCITT images (warning "JBig2 failed to initialize"), which blanked
// the text of scanned receipts. One shared object: react-pdf reloads the document when `options` changes identity.
const base = new URL(`${import.meta.env.BASE_URL}pdfjs/`, document.baseURI);
export const pdfOptions = Object.freeze({
  wasmUrl: new URL('wasm/', base).href,
  cMapUrl: new URL('cmaps/', base).href,
  standardFontDataUrl: new URL('standard_fonts/', base).href,
  iccUrl: new URL('iccs/', base).href,
});
